import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import ReactTooltip, { Place } from "react-tooltip"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { messages, getMessage, handleClick } from "./helpers.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    protectedClassName: string
    accountFeatureKey: string
    redirectToAccount: boolean
    className: string
    children: JSX.Element
    showLock: boolean
    module: string
    premium: boolean
    message: string
    to: string
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent) => void
    intl: Intl
    tooltipPlacement?: Place
}

const SpanWrapper = (props: OwnProps) => {
    const [displayModal, setDisplayModal] = useState(false)
    const showLock = props.showLock ?? true
    const lockedItem = <span key={"tooltip-container-span-wrapper"} data-tip data-for={"spanLock-span-wrapper"}>
        <span key={"span-wrapper"} className={props.protectedClassName}
            onClick={(e) => handleClick(e, props, setDisplayModal)}>
            <ReactTooltip place={props.tooltipPlacement ?? "top"}
                className="spanLock"
                id={"spanLock-span-wrapper"}
                type="warning"
                effect="solid"
                multiline={true}>
                {getMessage(props.message, props.intl.formatMessage(messages["update_subscription"]))}
            </ReactTooltip>
            {props.children} {showLock && <Icon value="lock" className="lock"/>}
        </span>
    </span>

    const item = <span key={"span-wrapper"} className={props.className} onClick={(e) => {
        props.onClick(e)
    }}>
        {props.children}
    </span>

    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={displayModal}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () {
                return
            }}
            onClickProtected={props.onClickProtected || function () {
                return
            }}
            onClose={() => {
                setDisplayModal(false)
                if (props.onClose) {
                    props.onClose()
                }
            }}
            onClick={props.onClick || function () {
                return
            }}
        >

        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(SpanWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/spanWrapper.component.tsx